/* Mumzers cart: upsell slot ("+ Add" -> size pills -> /cart/add.js -> theme cart refresh) */

if ( ! customElements.get('mz-cart-upsell') ) {
	customElements.define(
		'mz-cart-upsell',
		class MzCartUpsell extends HTMLElement {

			connectedCallback(){
				if ( this._mzBound ) return;
				this._mzBound = true;
				this.toggleButton = this.querySelector('[data-mz-upsell-toggle]');
				this.sizes = this.querySelector('.mz-upsell__sizes');
				this.error = this.querySelector('.mz-upsell__error');
				this.addEventListener('click', this.onClick.bind(this));
				this.initSelects();
			}

			initSelects(){
				const wrap = this.querySelector('[data-mz-selects]');
				const data = this.querySelector('[data-mz-variants]');
				if ( ! wrap || ! data ) return;
				try { this.mzVariants = JSON.parse(data.textContent); } catch(e) { this.mzVariants = []; }
				this.mzSelects = Array.from(wrap.querySelectorAll('select[data-mz-option]'));
				this.mzAdd = wrap.querySelector('[data-mz-combo-add]');
				this.mzSelects.forEach((sel, i) => sel.addEventListener('change', () => this.refreshSelects(i + 1)));
				this.refreshSelects(0);
			}

			refreshSelects(from){
				const sels = this.mzSelects;
				for ( let i = from; i < sels.length; i++ ) {
					const prior = sels.slice(0, i).map(s => s.value);
					const values = [];
					this.mzVariants.forEach(v => {
						if ( prior.every((val, j) => val !== '' && v.options[j] === val) && ! values.includes(v.options[i]) ) values.push(v.options[i]);
					});
					const keep = sels[i].value;
					sels[i].innerHTML = '';
					const ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Choose'; sels[i].appendChild(ph);
					values.forEach(val => { const o = document.createElement('option'); o.value = val; o.textContent = val; sels[i].appendChild(o); });
					sels[i].value = values.includes(keep) ? keep : ( values.length === 1 ? values[0] : '' );
					sels[i].disabled = values.length === 0;
				}
				const chosen = sels.map(s => s.value);
				const match = this.mzVariants.find(v => chosen.every((val, j) => val !== '' && v.options[j] === val));
				this.mzAdd.disabled = ! match;
				if ( match ) { this.mzAdd.dataset.mzVariantId = match.id; } else { delete this.mzAdd.dataset.mzVariantId; }
			}

			onClick(e){
				const variantButton = e.target.closest('[data-mz-variant-id]');
				if ( variantButton ) {
					e.preventDefault();
					if ( ! variantButton.disabled ) {
						this.addVariant(variantButton.dataset.mzVariantId, variantButton);
					}
					return;
				}
				if ( this.toggleButton && e.target.closest('[data-mz-upsell-toggle]') ) {
					e.preventDefault();
					const open = this.sizes.hidden;
					this.sizes.hidden = ! open;
					this.toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
					if ( open ) {
						const first = this.sizes.querySelector('[data-mz-variant-id]:not([disabled])');
						if ( first ) first.focus();
					}
				}
			}

			setLoading(loading, button){
				this.classList.toggle('mz-is-loading', loading);
				this.querySelectorAll('button').forEach(elm => {
					elm.disabled = loading || elm.hasAttribute('aria-disabled');
				});
				const target = this.toggleButton || button;
				if ( target ) {
					target.classList.toggle('mz-is-loading', loading);
					target.setAttribute('aria-busy', loading ? 'true' : 'false');
				}
				if ( button && button !== target ) {
					button.classList.toggle('mz-is-selected', loading);
				}
			}

			addVariant(variantId, button){
				const routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
				const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;

				this.error.hidden = true;
				this.setLoading(true, button);

				fetch(addUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
					body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
				})
					.then(response => response.json().then(data => ({ ok: response.ok, data })))
					.then(({ ok, data }) => {
						if ( ! ok ) {
							throw new Error(data.description || data.message || '');
						}
						if ( typeof window.refreshCart === 'function' ) {
							// re-renders bar, rows and this slot in place; an open drawer stays open
							return Promise.resolve(window.refreshCart(false));
						}
						window.location.reload();
					})
					.catch(err => {
						const locales = (window.KROWN && KROWN.settings && KROWN.settings.locales) || {};
						this.error.textContent = ( err && err.message ) || locales.cart_add_error || 'Something went wrong. Please try again.';
						this.error.hidden = false;
						this.setLoading(false, button);
						if ( this.mzSelects ) this.refreshSelects(this.mzSelects.length);
					});
			}

		}
	);
}

/* Mumzers: mobile sticky checkout bar on /cart, hidden while the summary's own Checkout is on screen */
(function(){
	let io = null, watched = null;
	function bind(){
		const main = document.getElementById('CheckOut');
		const bar = document.querySelector('[data-mz-sticky-checkout]');
		if ( ! bar ) return;
		document.body.classList.add('mz-has-sticky-checkout');
		const terms = document.getElementById('AgreeToTos');
		const btn = bar.querySelector('button');
		if ( btn && btn.hasAttribute('data-mz-needs-terms') ) {
			btn.addEventListener('click', e => {
				if ( terms && ! terms.checked ) { e.preventDefault(); terms.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
			});
		}
		if ( ! main || main === watched ) { if ( ! main ) bar.classList.add('mz-is-visible'); return; }
		if ( io ) io.disconnect();
		watched = main;
		io = new IntersectionObserver(entries => {
			entries.forEach(en => {
				document.querySelectorAll('[data-mz-sticky-checkout]').forEach(b => b.classList.toggle('mz-is-visible', ! en.isIntersecting));
			});
		});
		io.observe(main);
	}
	function start(){
		bind();
		const host = document.getElementById('AjaxCartSubtotal');
		if ( host ) new MutationObserver(() => { watched = null; bind(); }).observe(host, { childList: true });
	}
	if ( document.readyState === 'loading' ) document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Mumzers: hide chat bubble on /cart and while the cart drawer is open */
(function(){
	function update(){
		const d = document.getElementById('site-cart');
		let open = false;
		if ( d && getComputedStyle(d).display !== 'none' ) {
			const r = d.getBoundingClientRect();
			open = d.classList.contains('active') || ( r.width > 0 && r.right > 4 && r.left < window.innerWidth - 4 );
		}
		const onCart = document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname);
		document.body.classList.toggle('mz-hide-chat', onCart || open);
	}
	function start(){
		update();
		const d = document.getElementById('site-cart');
		if ( d ) new MutationObserver(update).observe(d, { attributes: true, attributeFilter: ['style', 'class', 'open', 'aria-hidden'] });
		document.addEventListener('click', () => { setTimeout(update, 400); setTimeout(update, 1000); });
	}
	if ( document.readyState === 'loading' ) document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Mumzers: shipping for currencies without their own settings — USD settings x Shopify live rate */
(function(){
	function fmt(cents, cur){
		const v = Math.round(cents) / 100;
		const whole = Math.abs(v - Math.round(v)) < 0.005;
		const n = v.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
		const sym = { EUR: '€', GBP: '£', USD: '$' }[cur];
		return sym ? sym + n : cur + ' ' + n;
	}
	function calc(el){
		const d = el.dataset, cur = d.currency;
		const zc = d.zoneCurrency;
		if ( ! zc ) return null;
		let rate = 1;
		if ( cur !== zc ) {
			// only convert from the shop's base currency (Shopify.currency.rate is base -> presentment)
			if ( zc !== d.shopCurrency ) return null;
			rate = parseFloat( window.Shopify && Shopify.currency && Shopify.currency.rate );
			if ( ! rate || isNaN(rate) ) return null;
		}
		const nice = c => Math.ceil(c * rate / 100) * 100;      // thresholds: whole units, rounded up
		const exact = c => Math.round(c * rate);                 // rates: exact conversion
		const l1 = nice(+d.l1 || 0), l2 = nice(+d.l2 || 0);
		const r = exact(+d.rate || 0), std = exact(+d.std || 0), t = +d.total || 0;
		const two = l1 > 0 && l1 < l2;
		let state = 'standard';
		if ( l2 > 0 && t >= l2 ) state = 'free'; else if ( two && t >= l1 ) state = 'reduced';
		const ship = state === 'free' ? 0 : state === 'reduced' ? r : std;
		return { cur, l1, l2, r, std, t, two, state, ship };
	}
	function setHTML(el, html){ if ( el.innerHTML !== html ) el.innerHTML = html; }
	function run(){
		document.querySelectorAll('[data-mz-ship-fallback]').forEach(el => {
			const c = calc(el);
			if ( ! c || ! c.l2 ) { el.hidden = true; return; }
			let msg, fill;
			if ( c.state === 'free' ) { msg = 'You’ve got <b>free shipping</b>'; fill = 100; }
			else if ( c.two && c.state === 'standard' ) { msg = '<b>' + fmt(c.l1 - c.t, c.cur) + '</b> to ' + fmt(c.r, c.cur) + ' shipping'; fill = c.t / c.l2 * 100; }
			else if ( c.two ) { msg = '<b>' + fmt(c.l2 - c.t, c.cur) + '</b> to free shipping'; fill = c.t / c.l2 * 100; }
			else { msg = '<b>' + fmt(c.l2 - c.t, c.cur) + '</b> to free shipping'; fill = c.t / c.l2 * 100; }
			setHTML(el.querySelector('.mz-ship__msg'), msg);
			{ const g2 = el.querySelector('.mz-ship__goal2'); if ( g2 ) { const gt2 = c.state === 'free' ? '' : 'Free shipping ' + fmt(c.l2, c.cur); if ( g2.textContent !== gt2 && g2.dataset.mzFull !== gt2 ) g2.textContent = gt2; g2.hidden = ! gt2; } }
			const e2 = el.querySelector('.mz-ship__end');
			if ( false && e2 ) { const et = c.state === 'free' ? '' : ( c.two && c.state === 'standard' ) ? fmt(c.r, c.cur) + ' shipping' : 'Free shipping'; if ( e2.textContent !== et ) e2.textContent = et; e2.hidden = ! et; }
			const g = el.querySelector('.mz-ship__goal');
			if ( g ) { const gt = c.state === 'free' ? '' : ( c.two && c.state === 'standard' ) ? fmt(c.r, c.cur) + ' at ' + fmt(c.l1, c.cur) : 'Free at ' + fmt(c.l2, c.cur); if ( g.textContent !== gt ) g.textContent = gt; g.hidden = ! gt; }
			const w = Math.min(100, Math.max(0, fill)).toFixed(1) + '%';
			(function(){ const tr = el.querySelector('.mz-ship__track'); let mid = el.querySelector('.mz-ship__stop--mid'); let lb = el.querySelector('.mz-ship__labels'); const end = el.querySelector('.mz-ship__end');
				if ( c.two ) {
					const pos = Math.round(c.l1 / c.l2 * 10000) / 100;
					if ( ! mid ) { mid = document.createElement('span'); mid.className = 'mz-ship__stop mz-ship__stop--mid'; mid.setAttribute('aria-hidden','true'); tr.appendChild(mid); }
					if ( mid.style.left !== pos + '%' ) mid.style.left = pos + '%';
					mid.classList.toggle('is-reached', c.state !== 'standard');
					const midR = c.state !== 'standard'; const midTxt = pos <= 80 ? fmt(c.r, c.cur) + ( pos > 62 ? '' : ' shipping' ) + ( midR ? ' unlocked' : '' ) : ''; const midShort = fmt(c.r, c.cur) + ( midR ? ' unlocked' : '' );
					const html = ( midTxt ? '<span class="mz-ship__lbl mz-ship__lbl--mid' + ( c.state !== 'standard' ? ' is-reached' : '' ) + '" style="left: ' + pos + '%" data-mz-short="' + midShort + '">' + midTxt + '</span>' : '' ) ;
					if ( ! lb ) { lb = document.createElement('div'); lb.className = 'mz-ship__labels'; tr.insertAdjacentElement('afterend', lb); }
					if ( lb.innerHTML !== html ) lb.innerHTML = html;
					if ( end ) end.hidden = true;
				} else if ( end ) { const et = c.state === 'free' ? '' : 'Free shipping'; if ( end.textContent !== et ) end.textContent = et; end.hidden = ! et; }
			})();
			const st = el.querySelector('.mz-ship__stop:not(.mz-ship__stop--mid)'); if ( st ) st.classList.toggle('is-reached', c.state === 'free');
			const f = el.querySelector('.mz-ship__fill'); if ( f.style.width !== w ) f.style.width = w;
			if ( el.hidden ) el.hidden = false;
		});
		document.querySelectorAll('[data-mz-js-ship]').forEach(el => {
			const c = calc(el);
			const txt = ! c ? 'Calculated at checkout' : c.state === 'free' ? 'Free' : fmt(c.ship, c.cur);
			if ( el.textContent !== txt ) el.textContent = txt;
			el.classList.toggle('mz-is-free', !! c && c.state === 'free');
		});
		document.querySelectorAll('[data-mz-js-total]').forEach(el => {
			const c = calc(el); if ( ! c ) return;
			const txt = fmt(c.t + c.ship, c.cur);
			if ( el.textContent !== txt ) el.textContent = txt;
		});
	}
	function start(){
		run();
		['AjaxCartForm', 'AjaxCartSubtotal', 'site-cart', 'section-cart'].forEach(id => {
			const n = document.getElementById(id);
			if ( n ) new MutationObserver(run).observe(n, { childList: true, subtree: true });
		});
	}
	if ( document.readyState === 'loading' ) document.addEventListener('DOMContentLoaded', start); else start();
})();

/* v18: drawer summary slot sync + robust 'Have a code?' toggle */
(function(){
  function sync(){var src=document.querySelector('#site-cart template[data-mz-drawer-summary-src]'),slot=document.querySelector('[data-mz-drawer-summary-slot]');
    if(src&&slot&&slot.innerHTML!==src.innerHTML)slot.innerHTML=src.innerHTML;}
  function boot(){var f=document.querySelector('#site-cart .sidebar__footer')||document.getElementById('site-cart');if(!f)return;sync();new MutationObserver(sync).observe(f,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('click',function(e){var s=e.target.closest&&e.target.closest('summary.mz-code__toggle');if(!s)return;
    e.preventDefault();e.stopPropagation();var d=s.parentElement;d.open=!d.open;
    if(d.open){var i=d.querySelector('input[name=discount]');if(i)setTimeout(function(){i.focus()},50);}},true);
})();

/* v26: keep shipping message on one line; drop the goal label when it doesn't fit */
(function(){
  function fit(){document.querySelectorAll('.mz-ship__head').forEach(function(h){
    var g=h.querySelector('.mz-ship__goal'),m=h.querySelector('.mz-ship__msg');if(!m||!h.offsetWidth)return;
    h.classList.remove('mz-goal-off','mz-msg-wrap','mz-goal-sm');var g2=h.querySelector('.mz-ship__goal2');
    var ov=function(){return h.scrollWidth>h.clientWidth+1||m.scrollWidth>m.clientWidth+1;};
    var has=g2&&g2.textContent.trim();
    if(has){var cur=g2.textContent;if(!g2.dataset.mzFull||(cur!==g2.dataset.mzFull&&cur!==g2.dataset.mzAmt)){g2.dataset.mzFull=cur;g2.dataset.mzAmt=cur.replace(/^Free shipping\s*/,'');}
      if(cur!==g2.dataset.mzFull)g2.textContent=g2.dataset.mzFull;
      if(ov())g2.textContent=g2.dataset.mzAmt;}
    if(has&&ov())h.classList.add('mz-goal-sm');
    if(has&&ov())h.classList.add('mz-goal-off');
    if(ov())h.classList.add('mz-msg-wrap');});}
  var q=0;function later(){cancelAnimationFrame(q);q=requestAnimationFrame(fit);}
  window.addEventListener('resize',later);document.addEventListener('transitionend',later,true);document.addEventListener('click',function(){setTimeout(later,350);},true);
  function boot(){fit();new MutationObserver(later).observe(document.body,{childList:true,subtree:true,characterData:true});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
    if(window.ResizeObserver){var ro=new ResizeObserver(later);document.querySelectorAll('#site-cart, main').forEach(function(n){ro.observe(n)});}}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* v33: shorten middle label if it would collide with the end label */
(function(){
  function fitLbl(){document.querySelectorAll('.mz-ship__labels').forEach(function(w){
    var m=w.querySelector('.mz-ship__lbl--mid'),e=w.querySelector('.mz-ship__lbl--end');if(!m||!e||!w.offsetParent||!w.offsetWidth)return;
    if(!m.dataset.mzFull)m.dataset.mzFull=m.textContent;
    if(m.textContent!==m.dataset.mzFull)m.textContent=m.dataset.mzFull;
    if(m.getBoundingClientRect().right+8>e.getBoundingClientRect().left&&m.dataset.mzShort)m.textContent=m.dataset.mzShort;});}
  var q=0;function later(){cancelAnimationFrame(q);q=requestAnimationFrame(fitLbl);}
  window.addEventListener('resize',later);
  function boot(){fitLbl();new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var t=ms[i].target;if(t.closest&&t.closest('.mz-ship__lbl'))return;}later();}).observe(document.body,{childList:true,subtree:true});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitLbl);
    document.addEventListener('transitionend',later,true);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();

/* speed: drawer wallet buttons are only inserted when the drawer is first opened */
(function(){
  function load(){var w=document.querySelector('[data-mz-lazy-wallets]');if(!w||w.classList.contains('mz-wallets-ready'))return;var t=w.querySelector('template');if(!t)return;
    w.appendChild(document.importNode(t.content,true));t.remove();w.classList.add('mz-wallets-ready');}
  function isOpen(d){return d.classList.contains('active')||(d.style.display!=='none'&&d.getBoundingClientRect().width>0&&d.getBoundingClientRect().right>0&&d.getBoundingClientRect().left<innerWidth);}
  function boot(){var d=document.getElementById('site-cart');if(!d)return;
    var mo=new MutationObserver(function(){if(isOpen(d)){load();mo.disconnect();}});mo.observe(d,{attributes:true,attributeFilter:['class','style']});
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href$="/cart"],[data-js-cart-icon],.cart-icon,[aria-controls="site-cart"]');if(a)setTimeout(load,50);},true);
    document.addEventListener('cart:open',load);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
